import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from 'react';
import { Button, Popconfirm, Space, Table } from 'antd';
import type { ColumnsType,} from 'antd/es/table';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { CategoryApi, CategoryDto, Configuration } from "../../api/najd";
import { getFullDateTime } from "../../helper";
import { API_URL } from "../../constants";

interface DataGridProps {
    onClickRowEdit: (rowData: any) => void;
    refreshTrigger: boolean;
    type: any;
    setRefreshTrigger: React.Dispatch<React.SetStateAction<boolean>>;
}

const CategoryTable: React.FC<DataGridProps> = ({ onClickRowEdit, refreshTrigger, setRefreshTrigger, type }) => {
    const { t } = useTranslation();
    const [userData, setUserData] = useState<CategoryDto[]>([]);
    const [loading, setLoading] = useState(false);

    const configuration = new Configuration({
        basePath: API_URL,
    });
    const categoryApi = new CategoryApi(configuration);
    
    const columns: ColumnsType<CategoryDto> = [
        {
            title: t('Code'),
            dataIndex: 'code',
            key: 'code',
        },
        {
            title: t('Name'),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: t('Short Description'),
            dataIndex: 'shortDescription',
            key: 'shortDescription',
        },
        // {
        //     title: t('Type'),
        //     dataIndex: 'type',
        //     key: 'type',
        // },
        {
            title: t('Creation Time'),
            dataIndex: 'creationTime',
            key: 'creationTime',
            render: ((date: string) => getFullDateTime(date))
        },
        {
            title: t('Active'),
            dataIndex: 'active',
            key: 'active',
            render: (active: boolean) => <span>{active ? 'Yes' : 'No'}</span>,
        },
    ];
    if (type !== 'party') {
        columns.splice(5, 0,{
            title: t('Action'),
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button type="primary" icon={<EditOutlined />} title={t('Edit')??''} onClick={() => { handleRowClick(record) }} />
                    <Popconfirm
                        title={t("Are you sure you want to delete this item?")}
                        onConfirm={() => handleDelete(record.id)}
                        okText={t("Yes")}
                        cancelText={t("No")}
                    >
                        <Button type="default" title={t('Delete')??''} icon={<DeleteOutlined />} danger
                            key={'con-btn-' + record.id} />
                    </Popconfirm>
                </Space>
            ),
        } );
    }
    // Use the onClickRowEdit function as needed
    const handleRowClick = (rowData: any) => {
        onClickRowEdit(rowData);
    };

    const handleDelete = (id: any) => {
        console.log('Clicked cancel button');
        categoryApi.categoryDelete(id)
            .then(response => {
                // Handle the API response            
                console.log(response.data);
                handleRefresh();
            })
            .catch(error => {
                // Handle the API error
                console.error(error);
            });
    };
    
    useEffect(() => {
        setLoading(true);
        const fetchUserData = async () => {
            try {
                const response = await categoryApi.categoryGetList(type);
                setUserData(response.data.items ?? []);
                setLoading(false);
            } catch (error) {
                console.error(error);
            }
        };
        fetchUserData();
    }, [refreshTrigger,type]); // Add refreshTrigger as a dependency

    const handleRefresh = () => {
        setRefreshTrigger((prevState) => !prevState); // Toggle the refresh trigger
    };

    return (<>
        {/* <button onClick={handleRefresh}>Refresh Data</button> */}
        <Table<CategoryDto>
            rowKey={(record) => record.id ?? ''}
            dataSource={userData}
            columns={columns}
            loading={loading}
        />
    </>
    );
};

export default CategoryTable;